/**
 * AuroraBackground component
 * Reusable animated gradient background with particles and mesh overlay
 * Creates a magical AI-themed atmosphere
 */

import type { ReactNode } from 'react';

import { AuthParticles } from '@/components/layout/AuthLayout/components/AuthParticles';

import './AuroraBackground.scss';

export interface AuroraBackgroundProps {
  children: ReactNode;
  className?: string;
}

/**
 * Animated aurora gradient background with floating particles
 */
export function AuroraBackground({ children, className = '' }: AuroraBackgroundProps) {
  return (
    <div className={`aurora-background ${className}`}>
      <AuthParticles />
      <div className="aurora-background-mesh"></div>
      {children}
    </div>
  );
}
